import { DogServiceIcon } from './DogServiceIcon';

/**
 * author: Michael Richins
 * id C0CF99F2-5D8E-4478-9602-9866AF83B94B
 * name dog-service
 * version: 2.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/dog-service.svg
 * tags
 * - Animal 
 */
export const K9Icon = DogServiceIcon;
export default K9Icon